import { Link } from 'react-router-dom';
import Sidebar from '../components/Sidebar';

const NotFound = () => (
  <div className="content">
    <Sidebar />
    <div className="main-content">
      <h1>Page not found</h1>
      <p>
        That page does not exist. It may have been renamed, or the link that
        brought you here may be out of date.
      </p>
      <p>
        <Link to="/home">Back to the homepage</Link>
      </p>
    </div>
  </div>
);

export default NotFound;
